import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppServerAPI } from '@sdbn/common';
import { ServiceResponse } from '@sdbn/common';
import { CMovementOrderTableRow, CancelMovingOrder, MovementOrderDetails, MovementOrderProcessingStatus, MovementOrderSelection, ProcessingStatusChange, ServiceTruckOption, TruckGroup } from './movement-orders.model';

@Injectable({
  providedIn: 'root'
})
export class MovementOrdersService {

  truckGroups = new Array<TruckGroup>();

  constructor(private appServerAPI: AppServerAPI) {
    this.truckGroups.push(new TruckGroup({ id: 1, name: 'Truck Gruppe 1' }));
    this.truckGroups.push(new TruckGroup({ id: 2, name: 'Truck Gruppe 2' }));
  }


  public getTruckGroups(): Observable<Array<TruckGroup>> {
    return this.appServerAPI.execute<Array<TruckGroup>>('/client/control/movement-orders/truck-groups', {})
      .pipe(
        map(
          options => options.map(o => new TruckGroup(o))
        )
      );
  }

  public loadServiceTruckOptions(): Observable<Array<ServiceTruckOption>> {
    return this.appServerAPI.execute<Array<ServiceTruckOption>>('/client/control/movement-orders/serice-truck-options', {})
      .pipe(
        map(
          options => options.map(o => new ServiceTruckOption(o))
        )
      );
  }

  public loadMovementOrderTableRowsForTruckGroup(serviceTruckId: number, truckGroupId: number): Observable<Array<CMovementOrderTableRow>> {
    const selection: MovementOrderSelection = {
      serviceTruckId,
      truckGroupId
    };

    return this.appServerAPI.execute<Array<CMovementOrderTableRow>>(
      '/client/control/movement-orders/table-rows',
      selection
    ).pipe(
      map(
        rows => rows.map(row => new CMovementOrderTableRow(row))
      )
    );
  }

  public loadMovementOrderDetails(movementOrderId: number): Observable<MovementOrderDetails> {
    return this.appServerAPI.execute<MovementOrderDetails>('/client/control/movement-orders/details',
      movementOrderId
    ).pipe(
      map(
        details => new MovementOrderDetails(details)
      )
    );
  }

  public handleStatusChange(request: ProcessingStatusChange): Observable<ServiceResponse> {

    return this.appServerAPI.execute<ServiceResponse>('/client/control/movement-orders/status-change', request)
      .pipe(
        map(r => new ServiceResponse(r))
      );
  }

  public handleStatusChangeReverse(movementOrderId: number, processingStatus: MovementOrderProcessingStatus): Observable<ServiceResponse> {

    const request: ProcessingStatusChange = {
      movementOrderId,
      processingStatus,
      serviceTruckId: null,
      vehicleId: null,
      targetStationId: null,
      reroutingTargetStationId: null
    };

    return this.appServerAPI.execute<ServiceResponse>('/client/control/movement-orders/status-change-reverse', request)
      .pipe(
        map(r => new ServiceResponse(r))
      );
  }

  public cancelMovingOrder(movementOrderId: number): Observable<ServiceResponse> {
    const request: CancelMovingOrder = {movementOrderId};

      return this.appServerAPI.execute<ServiceResponse>('/client/control/movement-orders/cancel', request)
      .pipe(
        map(r => new ServiceResponse(r))
      );
  }
}
